function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import useThemeProps from "../../hooks/useThemeProps";

function SvgHelpFilledIcon(props) {
  var c = useThemeProps();
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    width: props.size || '1em',
    height: props.size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8a8 8 0 1 0 16 0A8 8 0 0 0 0 8Zm5.985-2.377a.5.5 0 0 1-.97-.244L5.5 5.5l-.485-.121v-.002l.001-.003.002-.008.007-.025.024-.08A3.723 3.723 0 0 1 5.6 4.2C6.044 3.609 6.805 3 8.001 3c2.388 0 3.644 2.436 2.416 4.277-.418.628-.859 1.036-1.188 1.34a9.238 9.238 0 0 0-.25.237 1.65 1.65 0 0 0-.353.467c-.073.156-.125.362-.125.679a.5.5 0 0 1-1 0c0-.433.073-.79.219-1.102a2.63 2.63 0 0 1 .553-.752c.106-.106.213-.205.32-.305.32-.296.646-.599.992-1.118C10.356 5.564 9.612 4 8 4c-.803 0-1.293.391-1.6.8a2.723 2.723 0 0 0-.413.814l-.002.01ZM8.75 12a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z",
    fill: c[props.fill] || props.fill || "currentColor"
  }));
}

SvgHelpFilledIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
var Memo = /*#__PURE__*/memo(SvgHelpFilledIcon);
export default Memo;